
export default function LandingPage() {
  return (
    
  


<div class="bg-slate-50 text-slate-900 font-sans antialiased">

  <div class="bg-brand-900 text-white py-2 px-4 text-center text-sm font-medium">
    ✨ <span class="text-brand-200">Pilot Success:</span> 5000+ prints delivered at VNRVJIET. Join the next wave!
  </div>

  <header class="sticky top-0 z-50 glass border-b border-slate-200">
    <div class="mx-auto max-w-7xl px-4 py-4 flex items-center justify-between">
      <div class="flex items-center gap-2">
       
        <span class="text-xl font-extrabold tracking-tight text-brand-900 leading-none">ATP <span class="text-brand-600">Merchant</span></span>
      </div>
      
      <nav class="hidden md:flex items-center gap-8 text-sm font-semibold text-slate-600">
        <a href="#features" class="hover:text-brand-600 transition-colors">Features</a>
        <a href="#pilot" class="hover:text-brand-600 transition-colors">Pilot Results</a>
        <a href="#testimonials" class="hover:text-brand-600 transition-colors">Testimonials</a>
      </nav>

      <div class="flex items-center gap-4">
        <a href="#onboard" class="bg-brand-600 text-white px-5 py-2.5 rounded-full text-sm font-bold shadow-md hover:bg-brand-700 transition-all">Register Now</a>
      </div>
    </div>
  </header>

  <main>
    
     <section class="relative pt-20 pb-20 md:pt-32 md:pb-32 overflow-hidden px-4">
      <div class="mx-auto max-w-7xl relative z-10 text-center">
        <div class="inline-flex items-center gap-2 bg-brand-50 border border-brand-100 px-4 py-2 rounded-full mb-8">
          <span class="relative flex h-2 w-2">
            <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-success opacity-75"></span>
            <span class="relative inline-flex rounded-full h-2 w-2 bg-success"></span>
          </span>
          <span class="text-xs font-bold text-brand-700 uppercase tracking-widest">Accepting New Merchants</span>
        </div>
        <h2 class="text-5xl md:text-8xl font-display font-extrabold text-brand-900 tracking-tighter leading-[0.9] mb-8">
          Your Printer. <br class="hidden md:block"/> Our <span class="text-brand-600 underline decoration-brand-200 underline-offset-8">Cloud.</span>
        </h2>
        <p class="max-w-2xl mx-auto text-lg md:text-xl text-slate-600 leading-relaxed font-medium">
          Transform your Xerox shop into a 24/7 digital printing hub. Zero hardware cost. 100% automated workflow.
        </p>
      </div>
      <div class="absolute top-0 left-0 w-full h-full -z-10 pointer-events-none opacity-50">
        <div class="absolute top-1/4 -left-20 w-96 h-96 bg-brand-200 rounded-full blur-[120px]"></div>
        <div class="absolute bottom-1/4 -right-20 w-96 h-96 bg-blue-100 rounded-full blur-[120px]"></div>
      </div>
    </section>



   <section id="results" class="py-10 bg-brand-900 mx-4 md:mx-10 rounded-[2rem] md:rounded-[4rem] text-white">
      <div class="mx-auto max-w-7xl px-8">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
          <div>
            <div class="text-5xl font-display font-extrabold text-success mb-2">5K+</div>
            <div class="text-slate-400 text-sm font-bold uppercase tracking-widest">Prints at VNRVJIET</div>
          </div>
          <div class="md:border-x border-white/10">
            <div class="text-5xl font-display font-extrabold text-white mb-2">12s</div>
            <div class="text-slate-400 text-sm font-bold uppercase tracking-widest">Avg. Pick-up Time</div>
          </div>
          <div>
            <div class="text-5xl font-display font-extrabold text-brand-500 mb-2">100%</div>
            <div class="text-slate-400 text-sm font-bold uppercase tracking-widest">Digital Payouts</div>
          </div>
        </div>
      </div>
    </section>



    <section id="features" class="py-24 bg-slate-50">
        <div class="mx-auto max-w-7xl px-4">
            <div class="mb-16">
                <h2 class="text-3xl font-extrabold text-brand-900">Built for the Busy Merchant</h2>
                <p class="text-slate-600 mt-2">Why ATP is better than traditional shop management.</p>
            </div>
            <div class="grid md:grid-cols-3 gap-8">
                <div class="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm hover:shadow-xl transition-all group">
                    <div class="bg-brand-50 w-14 h-14 rounded-2xl flex items-center justify-center text-brand-600 group-hover:bg-brand-600 group-hover:text-white transition-colors">
                        <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 004.561 21h14.878a2 2 0 001.94-1.515L22 17" /></svg>
                    </div>
                    <h3 class="mt-6 text-xl font-bold">Zero Downloads</h3>
                    <p class="mt-3 text-slate-600 text-sm leading-relaxed">Print directly from the cloud. Your shop PC stays clean, fast, and free of viruses from customer pen-drives.</p>
                </div>
                <div class="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm hover:shadow-xl transition-all group">
                    <div class="bg-brand-50 w-14 h-14 rounded-2xl flex items-center justify-center text-brand-600 group-hover:bg-brand-600 group-hover:text-white transition-colors">
                        <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
                    </div>
                    <h3 class="mt-6 text-xl font-bold">Secure Orders</h3>
                    <p class="mt-3 text-slate-600 text-sm leading-relaxed">Only print once the customer is at the counter.</p>
                </div>
                <div class="bg-white p-8 rounded-3xl border border-slate-200 shadow-sm hover:shadow-xl transition-all group">
                    <div class="bg-brand-50 w-14 h-14 rounded-2xl flex items-center justify-center text-brand-600 group-hover:bg-brand-600 group-hover:text-white transition-colors">
                        <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                    </div>
                    <h3 class="mt-6 text-xl font-bold">Automatic Accounting</h3>
                    <p class="mt-3 text-slate-600 text-sm leading-relaxed">Payments are handled by ATP. No more "I'll pay later" or "Where is the change?" See your daily revenue in one tap.</p>
                </div>
            </div>
        </div>
    </section>

    <section id="testimonials" class="py-24 bg-brand-900 text-white overflow-hidden">
        <div class="mx-auto max-w-7xl px-4">
            <div class="flex flex-col md:flex-row justify-between items-end mb-12 gap-6">
                <div class="max-w-xl">
                    <h2 class="text-3xl md:text-4xl font-extrabold text-brand-100">What the VNRVJIET Community says</h2>
                    <p class="text-brand-200/70 mt-4 text-lg">Real feedback from our pilot run at Vallurupalli Nageswara Rao Vignana Jyothi Institute of Engineering and Technology.</p>
                </div>
                <div class="bg-white/10 px-6 py-4 rounded-2xl backdrop-blur border border-white/10">
                    <div class="text-accent text-2xl font-bold">4.9/5.0</div>
                    <div class="text-xs font-semibold uppercase tracking-widest text-brand-200/50">Average Rating</div>
                </div>
            </div>

            <div class="no-scrollbar flex gap-6 overflow-x-auto pb-8">
                <div class="min-w-[350px] bg-white/5 border border-white/10 p-8 rounded-3xl">
                    <div class="flex gap-1 text-emerald-400 mb-4">
                        <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" /></svg>
                        <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" /></svg>
                        <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" /></svg>
                        <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" /></svg>
                        <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" /></svg>
                    </div>
                    <p class="text-brand-100/90 leading-relaxed italic">"The rush at the Xerox center during exam season used to be chaotic. With ATP, students already have their OTPs ready. I just type it and click print. It saved me at least 4 hours of manual effort daily."</p>
                    <div class="mt-6 flex items-center gap-4">
                        <div class="w-10 h-10 bg-brand-500 rounded-full flex items-center justify-center font-bold">M</div>
                        <div>
                            <div class="font-bold text-white">VNRVJIET </div>
                            <div class="text-xs text-brand-400 font-semibold">Lab 1 Hub</div>
                        </div>
                    </div>
                </div>
                <div class="min-w-[350px] bg-white/5 border border-white/10 p-8 rounded-3xl">
                    <p class="text-brand-100/90 leading-relaxed italic">"I love that I don't have to carry cash or wait for change. I upload my lab records from my hostel, pay via UPI, and just pick up the prints on my way to class. No more crowds!"</p>
                    <div class="mt-14 flex items-center gap-4">
                        <div class="w-10 h-10 bg-emerald-500 rounded-full flex items-center justify-center font-bold">S</div>
                        <div>
                            <div class="font-bold text-white">Student (ECE Department)</div>
                            <div class="text-xs text-brand-400 font-semibold">VNRVJIET 3rd Year</div>
                        </div>
                    </div>
                </div>
                 <div class="min-w-[350px] bg-white/5 border border-white/10 p-8 rounded-3xl">
                    <p class="text-brand-100/90 leading-relaxed italic">"As a shop owner, tracking small ₹2 and ₹5 payments was a nightmare. ATP summarizes everything. I know exactly how much I earned at the end of the day."</p>
                    <div class="mt-14 flex items-center gap-4">
                        <div class="w-10 h-10 bg-brand-200 rounded-full flex items-center justify-center font-bold text-brand-900 text-xs">A</div>
                        <div>
                            <div class="font-bold text-white">Akshay K.</div>
                            <div class="text-xs text-brand-400 font-semibold">Pilot Partner</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section id="onboard" class="py-24 bg-white">
        <div class="mx-auto max-w-7xl px-4 grid md:grid-cols-2 gap-16 items-center">
            <div>
                <h2 class="text-4xl font-extrabold text-brand-900 tracking-tight leading-tight">Join the Network.<br/><span class="text-brand-600">Upgrade Your Shop Today.</span></h2>
                <p class="mt-6 text-slate-600 leading-relaxed">Fill out this quick form. Our team will visit your shop for a technical setup and verify your printer compatibility (Works with HP, Canon, Epson, Brother, and more).</p>
                
                <ul class="mt-10 space-y-4">
                    <li class="flex items-center gap-3 text-slate-700 font-medium">
                        <div class="w-6 h-6 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center">✓</div>
                        Free technical setup by our Team
                    </li>
                    <li class="flex items-center gap-3 text-slate-700 font-medium">
                        <div class="w-6 h-6 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center">✓</div>
                        Digital Merchant Dashboard access
                    </li>
                    <li class="flex items-center gap-3 text-slate-700 font-medium">
                        <div class="w-6 h-6 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center">✓</div>
                        Weekly settlement of earnings
                    </li>
                </ul>
            </div>

            <div class="bg-slate-50 p-8 md:p-10 rounded-[2.5rem] border border-slate-200 shadow-2xl">
                <form class="space-y-5">
                    <div class="grid grid-cols-2 gap-4">
                        <div class="col-span-2">
                            <label class="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Shop Name</label>
                            <input type="text" placeholder="e.g. Balaji Xerox Hub" class="w-full px-5 py-4 rounded-2xl border border-slate-200 focus:border-brand-500 focus:ring-4 focus:ring-brand-100 outline-none transition-all" />
                        </div>
                        <div>
                            <label class="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Owner Name</label>
                            <input type="text" placeholder="Your Name" class="w-full px-5 py-4 rounded-2xl border border-slate-200 focus:border-brand-500 focus:ring-4 focus:ring-brand-100 outline-none transition-all" />
                        </div>
                        <div>
                            <label class="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Mobile Number</label>
                            <input type="tel" placeholder="10-digit number" class="w-full px-5 py-4 rounded-2xl border border-slate-200 focus:border-brand-500 focus:ring-4 focus:ring-brand-100 outline-none transition-all" />
                        </div>
                        <div class="col-span-2">
                            <label class="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Location/City</label>
                            <input type="text" placeholder="Street, City" class="w-full px-5 py-4 rounded-2xl border border-slate-200 focus:border-brand-500 focus:ring-4 focus:ring-brand-100 outline-none transition-all" />
                        </div>
                    </div>
                    <button class="w-full bg-brand-600 text-white font-bold py-5 rounded-2xl shadow-lg shadow-brand-200 hover:bg-brand-700 hover:-translate-y-1 transition-all">Submit Registration</button>
                    <p class="text-center text-[10px] text-slate-400 uppercase font-bold tracking-tighter">By clicking, you agree to our merchant terms & privacy policy</p>
                </form>
            </div>
        </div>
    </section>
  </main>

  <footer class="bg-brand-900 text-white pt-24 pb-12">
    <div class="mx-auto max-w-7xl px-6">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
        <div class="lg:col-span-1">
          <div class="flex items-center gap-2 mb-6">
            
            <span class="text-xl font-display font-extrabold tracking-tight">Any Time Print - ATP</span>
          </div>
          <p class="text-slate-400 text-sm leading-relaxed mb-6">
            Revolutionizing the campus printing ecosystem through smart cloud solutions. A proud product of Saola Innovations.
          </p>
          <div class="flex gap-4">
            <a href="#" class="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-600 transition-colors"><svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/></svg></a>
            <a href="#" class="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-brand-600 transition-colors"><svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5v-14c0-2.761-2.239-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg></a>
          </div>
        </div>

        <div>
          <h4 class="font-bold text-white mb-6 uppercase text-xs tracking-[0.2em]">Merchant Resources</h4>
          <ul class="space-y-4 text-sm text-slate-400">
            <li><a href="#" class="hover:text-white transition-colors">Pricing Structure</a></li>
            <li><a href="#" class="hover:text-white transition-colors">Printer Setup Guide</a></li>
            <li><a href="#" class="hover:text-white transition-colors">Payout Schedule</a></li>
            <li><a href="#" class="hover:text-white transition-colors">VNRVJIET Case Study</a></li>
          </ul>
        </div>

        <div>
          <h4 class="font-bold text-white mb-6 uppercase text-xs tracking-[0.2em]">Platform</h4>
          <ul class="space-y-4 text-sm text-slate-400">
            <li><a href="https://saola.in" target="_blank" class="hover:text-white transition-colors">Saola Innovations</a></li>
            <li><a href="#" class="hover:text-white transition-colors">Student Portal</a></li>
            <li><a href="#" class="hover:text-white transition-colors">API for Developers</a></li>
            <li><a href="#" class="hover:text-white transition-colors">Security Center</a></li>
          </ul>
        </div>

        <div>
          <h4 class="font-bold text-white mb-6 uppercase text-xs tracking-[0.2em]">Support Line</h4>
          <p class="text-sm text-slate-400 mb-4">Urgent merchant onboarding assistance:</p>
          <a href="mailto:support@anytimeprint.in" class="text-brand-500 font-bold hover:underline block mb-2">info@saola.in</a>
          <p class="text-xs text-slate-500">Response time: &lt; 8 hours</p>
        </div>
      </div>

      <div class="border-t border-white/5 pt-12 flex flex-col md:flex-row justify-between items-center gap-6">
        <p class="text-slate-500 text-xs font-medium">© 2026 Any Time Print (ATP). All Rights Reserved. Built by Saola Innovations.</p>
        <div class="flex gap-8 text-[10px] font-bold text-slate-500 uppercase tracking-widest">
          <a href="#" class="hover:text-white transition-colors">Terms of Business</a>
          <a href="#" class="hover:text-white transition-colors">Privacy</a>
          <a href="#" class="hover:text-white transition-colors">Compliance</a>
        </div>
      </div>
    </div>
  </footer>


</div>

  );
}